import styled from '@emotion/styled'
import { Groupbox } from 'view/components/panels'

export const Content = styled(Groupbox)`
  min-width: 410px;
  min-height: 450px;
  max-height: calc(100vh - 300px);
  overflow-y: auto;
  padding: 0 20px;

  & > * {
    margin-bottom: 19px;
  }
`

export const GridWrapper = styled.div<{ height: number }>`
  height: ${props => props.height}px;
  width: 100%;
`
